import React, { useState, useEffect } from 'react';
import { FaStar, FaRegStar, FaInfoCircle } from 'react-icons/fa';
import { getFeedbacks } from '../services/api';
import './Reviews.css';

function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all');

  const loadReviews = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const params = filter !== 'all' ? { rating: filter } : {};
      const response = await getFeedbacks(params);
      
      if (response.data && response.data.length > 0) {
        setReviews(response.data);
      } else {
        setReviews([]);
      }
    } catch (err) {
      console.error('Error loading reviews:', err);
      setError('Unable to load reviews at this time.');
      setReviews([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const renderStars = (rating) => {
    return (
      <div className="stars">
        {[1, 2, 3, 4, 5].map(star => (
          star <= rating ? 
            <FaStar key={star} className="star filled" /> : 
            <FaRegStar key={star} className="star" />
        ))}
      </div>
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="reviews-page">
      <div className="container">
        <div className="reviews-header">
          <h1>Customer Reviews</h1>
          <p>See what our customers are saying about RiftOne</p>
        </div>

        <div className="reviews-filters">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Reviews
          </button>
          {[5, 4, 3, 2, 1].map(rating => (
            <button 
              key={rating}
              className={`filter-btn ${filter === rating ? 'active' : ''}`}
              onClick={() => setFilter(rating)}
            >
              {rating} {renderStars(rating)}
            </button>
          ))}
        </div>

        {loading && (
          <div className="reviews-loading">
            <div className="spinner"></div>
            <p>Loading reviews...</p>
          </div>
        )}

        {!loading && error && (
          <div className="reviews-error">
            <FaInfoCircle className="error-icon" />
            <h3>{error}</h3>
          </div>
        )}

        {!loading && !error && reviews.length === 0 && (
          <div className="reviews-empty">
            <FaInfoCircle className="empty-icon" />
            <h3>No Reviews Yet</h3>
            <p>Be the first to leave a review after your purchase!</p>
          </div>
        )}

        {!loading && !error && reviews.length > 0 && (
          <div className="reviews-list">
            {reviews.map(review => (
              <div key={review.id} className="review-card">
                <div className="review-header">
                  <div className="review-rating">
                    {renderStars(review.rating)}
                    <span className="rating-number">{review.rating}/5</span>
                  </div>
                  <span className="review-date">{formatDate(review.created_at)}</span>
                </div>

                <div className="review-content">
                  <p className="review-message">{review.message}</p>
                  
                  {review.product && (
                    <div className="review-product">
                      <span className="product-badge">Product: {review.product.name}</span>
                    </div>
                  )}

                  {review.reply && (
                    <div className="review-reply">
                      <strong>RiftOne Response:</strong>
                      <p>{review.reply}</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Reviews;
